import { Box, Skeleton as MantineSkeleton, createStyles } from '@mantine/core';

const useSkeletonStyle = createStyles(() => ({
  outerContainer: {
    overflow: 'hidden',
  },
}));

const Skeleton = ({
  lines = 1,
  width = '100%',
  height,
  isImage = false,
  contentH = 18,
  last = true,
}: {
  lines?: number;
  height?: number;
  isImage?: boolean;
  width?: string | number;
  contentH?: number;
  last?: boolean;
}) => {
  const { classes } = useSkeletonStyle();

  return isImage ? (
    <MantineSkeleton animate width={width} height={height} />
  ) : (
    <Box className={classes.outerContainer} sx={{ height, width }}>
      {Array(lines - 1)
        .fill(0)
        .map((_, index) => (
          <MantineSkeleton animate key={index} height={contentH} mt={12} />
        ))}
      {last && (
        <MantineSkeleton animate height={contentH} mt={12} width={'66%'} />
      )}
    </Box>
  );
};

export default Skeleton;
